import { fetchData } from '../utils/api';
import type { CurrencyContextEntry } from '../utils/currencyContext';

export interface ActiveCurrenciesResponse {
  count: number;
  /**
   * Task 2.10: typed as CurrencyContextEntry (not the bare MoneyCurrency
   * twin) because the wire payload (currency.controller.ts's toWireShape)
   * already includes usdRateUpdatedAt — the type was just missing it.
   */
  currencies: CurrencyContextEntry[];
}

/**
 * Task 2.9 — thin fetch wrapper for GET /currencies/active, mirroring the
 * frontend/src/services/*.service.ts pattern (e.g. address.service.ts).
 * Feeds frontend/src/utils/currencyContext.ts's setCurrencyContext.
 */
const CurrencyService = {
  getActiveCurrencies: async () => {
    return await fetchData<ActiveCurrenciesResponse>('/currencies/active');
  },
};

export default CurrencyService;
